import { ConvertedComponentData, FsCatalog, ImageData } from '../../../cms/components/types'
import { TrainingCategoriesConverter } from './training-categories.converter'
import { InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'

export interface TrainingCategoriesItemData {
  categoryId?: string;
  image?: ImageData;
}

export interface TrainingCategoriesData extends ConvertedComponentData {
  items?: FsCatalog<TrainingCategoriesItemData>;
}

export const TRAINING_CATEGORIES_CONVERTER =
  new InjectionToken<Converter<CmsComponent, TrainingCategoriesData>[]>('TrainingCategoriesConverter')
